<template>
	<div>
		<div class="routerOrgMenu">
			<router-link class="routerOrgMenuItem" to="/org/frame"><p class="routerOrgMenuItemTit">Company Structure</p></router-link>
			<router-link class="routerOrgMenuItem" to="/org/leader"><p class="routerOrgMenuItemTit">Leadership</p></router-link>
		</div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: "Org"
}
</script>

<style scoped>
	.routerOrgMenu{ font-family: 'SiYuan-Light', sans-serif; }
	@media (max-width: 465px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerOrgMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 80%; display: flex; flex-wrap: nowrap; animation: fadeInLeft; animation-duration: 1s; }
		.routerOrgMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 49%; display: block; text-align: center; }
		.routerOrgMenuItem:hover{ color: #07c7f1; letter-spacing: 2px; }
		.routerOrgMenuItemTit{ transition: all 0.2s linear; display: block; height: 36px; line-height: 46px; margin: 0; }
	}
	@media (min-width: 465px) and (max-width: 726px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerOrgMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 80%; display: flex; flex-wrap: nowrap; animation: fadeInLeft; animation-duration: 1s; }
		.routerOrgMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 49%; display: block; text-align: center; }
		.routerOrgMenuItem:hover{ color: #07c7f1; letter-spacing: 2px; }
		.routerOrgMenuItemTit{ transition: all 0.2s linear; display: block; height: 36px; line-height: 46px; margin: 0; }
	}
	@media (min-width: 726px){
		.router-link-active{ color: #07b1db !important; border-bottom: 1px solid #07b1db; }
		.routerOrgMenu{ height: 36px; border-bottom: 1px solid #e1edff; width: 330px; display: flex; flex-wrap: nowrap; animation: fadeInLeft; animation-duration: 1s; }
		.routerOrgMenuItem{ text-decoration: none; color: #d0d0d0; font-size: 13px; height: 100%; width: 49%; display: block; text-align: center; }
		.routerOrgMenuItem:hover{ color: #07c7f1; letter-spacing: 2px; }
		.routerOrgMenuItemTit{ transition: all 0.2s linear; display: block; height: 36px; line-height: 46px; margin: 0; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
	}
	@media (min-width: 1252px) and (max-width: 1759px){
	}
	@media (min-width: 1760px) and (max-width: 2200px){
	}
	@media (min-width: 2201px){
	}
</style>